    @import '../../utils/global.module.less';

.saveForTestsButton {
    padding: 8px 16px;
    background-color: #1976d2;
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    &:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
        background-color: #1565c0;
    }
}

.saveForTestsContainer {
    margin-right: 10px;
} 